module.exports = __webpack_public_path__ + "img/blog6-logo-9.44066ed7.webp";